import * as types from '../actiontypes';

export function addOverWriteDocument(document) {
	return {
		type: types.ADD_DUPLICATE_DOCUMENT,
		meta: {
			document: document
		}
	};
}

export function clearDuplicateDocuments(payload) {
	return {
		type: types.CLEAR_DUPLICATE_DOCUMENTS,
		payload
	};
}

// Duplicate function removed

export function updateGLAccountUploadingCount(actionType) {
	return {
		type: types.UPDATE_GLACCOUNT_DOCUPLOAD_COUNT,
		payload: actionType
	};
}

export function removeTaskDocument(document) {
	return {
		type: types.REMOVE_TASK_DOCUMENT,
		documentName: document.documentName,
		parentName: document.payload.parentName
		//TODO Send meta like shown below and remove sending parentName directly in action
		// meta: {
		// 	docHelper: {
		// 		payload: {
		// 			parentName: document.payload.parentName
		// 		}
		// 	}
		// }
	};
}

export function selectDocumentOverwrite(relatedEntityId, documentId, documentName, isOverwrite, parentName) {
	return {
		type: types.SELECT_DOCUMENT_OVERWRITE,
		relatedEntityId,
		parentName,
		meta: {
			documentId,
			documentName,
			isOverwrite: isOverwrite
		}
	};
}

export function clientRequestselectDocumentOverwrite(documentId, fileId, documentName, isOverwrite, parentName) {
	return {
		type: 'CLIENTREQUEST_OVERWRITE_DOCUMENT',
		parentName,
		meta: {
			documentId,
			fileId,
			documentName,
			isOverwrite: isOverwrite
		}
	};
}

export function removeClientRequestDocument(document) {
	return {
		type: 'CLEAR_CLIENTREQUEST_DOCUMENT',
		fileId: document.fileId
	};
}
